// extracted by mini-css-extract-plugin
module.exports = {"modal-form-wrapper__form":"modal-form-wrapper_modal-form-wrapper__form__fhXUT","modal-form-wrapper__form-controls":"modal-form-wrapper_modal-form-wrapper__form-controls__HDdk2"};